import api from "@/api/axiosInstance";
import type { DashboardProfileMetadata } from "@/dashboard/utils/dashboard.types";

export type SidebarEntryType = "DASHBOARD" | "PULSE" | "LINK";

export type DashboardNavigation = {
    type: "DASHBOARD";
    mountPath: string;
    productInstanceId: number;
    taskInstanceId: number;
};

export type PulseNavigation = {
    type: "PULSE";
    mountPath: string;
    pulseInstanceId: number;
};

type SidebarEntryBase = {
    id: number;
    key: string;
    name: string;
    productInstanceName: string | null;
    pulseInstanceId: number | null;
    profiles: DashboardProfileMetadata[];
    url: string | null;
    navigation: DashboardNavigation | PulseNavigation | null;
};

type DashboardSidebarEntry = Omit<SidebarEntryBase, "navigation"> & {
    type: "DASHBOARD";
    isUpsell: boolean;
    navigation: Extract<NonNullable<SidebarEntryBase["navigation"]>, { type: "DASHBOARD" }>;
};

type LinkSidebarEntry = SidebarEntryBase & {
    type: "LINK";
    isUpsell: boolean;
};

type PulseUpsellSidebarEntry = SidebarEntryBase & {
    type: "PULSE";
    isUpsell: true;
};

type PulseRouteSidebarEntry = SidebarEntryBase & {
    type: "PULSE";
    isUpsell: false;
};

export type SidebarEntry =
    | DashboardSidebarEntry
    | LinkSidebarEntry
    | PulseUpsellSidebarEntry
    | PulseRouteSidebarEntry;

type SidebarEntriesResponse = {
    selectedCustomer: SidebarCustomer;
    availableCustomers: SidebarCustomer[];
    entries: SidebarEntry[];
};

type SidebarEntriesApiResponse = {
    selectedCustomer: SidebarCustomer;
    availableCustomers: SidebarCustomer[];
    entries: SidebarEntry[];
};

export type SidebarCustomer = {
    id: number;
    name: string;
};

const getSidebarEntries = async (customerId: number): Promise<SidebarEntriesResponse> => {
    const response = (await api.get(`sidebar/${customerId}`)).data
        .data as SidebarEntriesApiResponse;
    return {
        selectedCustomer: response.selectedCustomer,
        availableCustomers: response.availableCustomers,
        entries: response.entries,
    };
};

const getSidebarCustomers = async (): Promise<SidebarCustomer[]> => {
    return (await api.get("sidebar/customers")).data.data as SidebarCustomer[];
};

export { getSidebarCustomers, getSidebarEntries };
